<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: space-between">
        <div class="btn-box">
          <el-date-picker
            v-model="timeValue"
            type="daterange"
            size="small"
            unlink-panels
            @change="changeTimeValue"
            :picker-options="pickerOptions2"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>

        <!--<input-select selectTitle="缴费方式" :selectKey="'payChannel'" :selectData="payChannelList" @search="search"/>-->
      </div>
      <div class="btn-box">
        <input-search placeholder="设备名称/巡检员" @search="searchKey" />
        <button-export
          :href="exportUrl"
          download="download.xls"
          style="margin-left: 10px;"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('024007002') !== -1"
          value="导出"/>
      </div>

    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @lookOver="seeExample" :hasOperation="false" />

    <preview-image :z-index="99999" :initial-index="previewImageIndex" :on-close="closeViewer" :url-list="snapImagePreviewArr" v-if="showPreviewImage" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/Inspection'
  import {bus} from '../../../utils/bus'
  import {errorHandler} from '../../../utils/errorHandler'
  import PreviewImage from '../../../components/Img/previewImage'
  import {nError} from '../../../utils/notice'

  export default {
    components: {
      PreviewImage,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'inspection-record',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧巡检',
          name: 'inspection-device-type-manage'
        }, {
          value: '巡检记录'
        }],
        exportUrl: '',
        deviceStatusList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '正常',
            label: '正常'
          }, {
            key: '故障',
            label: '故障'
          }, {
            key: '报废',
            label: '报废'
          }
        ],
        tableHead: [{
          prop: 'inspectionPoint',
          label: '巡检点',
        }, {
          prop: 'inspectionCode',
          label: '巡检码',
        }, {
          prop: 'inspectionPerson',
          label: '巡检人员'
        }, {
          prop: 'taskName',
          label: '巡检任务',
          width: '300'
        }, {
          prop: 'planName',
          label: '所属计划',
        }, {
          prop: 'createTime',
          label: '巡检时间'
        }, {
          prop: 'pointStatus',
          explain: 'explain',
          isStatusHasExplain: true,
          label: '运行状态'
        }, {
          prop: 'sitePhotoUrl',
          isLookOver: true,
          label: '巡检图片'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        timeValue: [],
        pickerOptions2: {
          disabledDate (time) {
            return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        requestData: {
          searchKey: '',
          deviceStatus: '',
        },

        snapDialogVisible: false,
        snapDialogData: [],
        snapImagePreviewArr: [],
        previewImageIndex: 0,
        showPreviewImage: false,
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes

      this.getCreateTime()
    },
    activated() {
      this.getPage()
    },
    methods: {
      seeExample (data) {
        this.snapImagePreviewArr = [data]
        this.showPreviewImage = true
      },
      closeViewer() {
        this.showPreviewImage = false
      },
      getCreateTime () {
        let nowDate = new Date
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
        // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
        // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
        this.timeValue[0] = year + '-' + month + '-01'
        this.timeValue[1] = year + '-' + month + '-' + date
        this.getPage()
      },
      beforeDownload () {
        this.exportUrl = `${api.exportInspectionRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&payStatus=${this.requestData.payStatus}`
      },
      changeTimeValue () {
        this.pageNum = 1
        this.pageSize = 10
        this.getPage()
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        if (this.timeValue) {
          reqData.startTime = `${this.timeValue[0]} 00:00:00`
          reqData.endTime = `${this.timeValue[1]} 23:59:59`
        }else{
          reqData.startTime = ''
          reqData.endTime = ''
        }
        this.$axios.post(api.getInspectionRecordPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                if (v.runStatus === '1') {
                  v.pointStatus = '0'
                } else {
                  v.pointStatus = '1'
                }
                if (v.executeState === '0') {
                  v.executeStateText = '按时完成'
                } else if (v.executeState === '1') {
                  v.executeStateText = '计划外完成'
                }
                if (v.createTime) {
                  v.createTime = v.createTime.slice(0, 19)
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Inspection/InspectionRecord/InspectionRecord.vue